import { Trans } from '@lingui/macro'
import styled from 'styled-components/macro'

const Status = styled.span<{ $removed: boolean; $inRange: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: ${({ theme, $removed, $inRange }) =>
    $removed ? theme.textSecondary : $inRange ? theme.accentSuccess : theme.accentWarning};
  font-size: 11px;
  font-weight: 600;
  line-height: 16px;
`

export default function PositionRangeStatus({ removed = false, inRange }: { removed?: boolean; inRange?: boolean }) {
  return (
    <Status $removed={removed} $inRange={Boolean(inRange)}>
      <span aria-hidden="true">●</span>
      {removed ? <Trans>Closed</Trans> : inRange ? <Trans>In range</Trans> : <Trans>Out of range</Trans>}
    </Status>
  )
}
